import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

import Agencias from "./components/Agencias";
import Atuacao from "./components/Atuacao";
import Contato from "./components/Contato";
import Diferenciais from "./components/Diferenciais";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Piloto from "./components/Piloto";
import Processo from "./components/Processo";
import Tecnologias from "./components/Tecnologias";

function App() {
    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    return (
        <>
            <body className="index-page">
                <Header />

                <main className="main">
                    <Hero />

                    <Atuacao />

                    <Tecnologias />

                    <Processo />

                    <Diferenciais />

                    <Piloto />

                    <Agencias />

                    <Faq />

                    <Contato />

                    <Footer />
                </main>
            </body>
        </>
    );
}

export default App;
